import { MatchData, RoundEnd } from "../types/match.types";

export const normalizeMatchData = (matches: MatchData[]): MatchData[] => {
	if (matches.length <= 1) return matches;

	const referenceMatch = matches[0];
	const referenceTeam1Id = referenceMatch.team1.teamId;
	const referenceTeam2Id = referenceMatch.team2.teamId;
	const referenceTeam1Info = referenceMatch.team1;
	const referenceTeam2Info = referenceMatch.team2;

	return matches.map((match, index) => {
		if (index === 0) return match;

		const team1IdMatchesReference = match.team1.teamId === referenceTeam1Id;
		const team2IdMatchesReference = match.team2.teamId === referenceTeam2Id;
		const team1NameCorrect =
			match.team1.teamName === referenceTeam1Info.teamName;
		const team2NameCorrect =
			match.team2.teamName === referenceTeam2Info.teamName;

		if (
			team1IdMatchesReference &&
			team2IdMatchesReference &&
			(!team1NameCorrect || !team2NameCorrect)
		) {
			return {
				...match,
				team1: {
					...match.team1,
					teamName: referenceTeam1Info.teamName,
					teamLogo: referenceTeam1Info.teamLogo,
				},
				team2: {
					...match.team2,
					teamName: referenceTeam2Info.teamName,
					teamLogo: referenceTeam2Info.teamLogo,
				},
			};
		} else if (!team1IdMatchesReference && !team2IdMatchesReference) {
			return {
				...match,
				team1: {
					...match.team2,
					teamName: referenceTeam1Info.teamName,
					teamLogo: referenceTeam1Info.teamLogo,
				},
				team2: {
					...match.team1,
					teamName: referenceTeam2Info.teamName,
					teamLogo: referenceTeam2Info.teamLogo,
				},
				team1playerids: match.team2playerids,
				team2playerids: match.team1playerids,
				team1score: match.team2score,
				team2score: match.team1score,
				team1won: !match.team1won,
				roundEnds: Object.entries(match.roundEnds).reduce(
					(acc, [roundNum, roundData]) => {
						acc[roundNum] = {
							...roundData,
							teamWonID:
								roundData.teamWonID === match.team1.teamId
									? match.team2.teamId
									: match.team1.teamId,
						};
						return acc;
					},
					{} as { [key: string]: RoundEnd }
				),
			};
		}

		return match;
	});
};